(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["customer-reviews"]) return;
  try {
    

$('.review-row').slick({
	infinite: true,
	autoplay: true,
	arrows: true,
	prevArrow: "<i class='fa fa-chevron-left review-slider-arrow slick-prev'></i>",
	nextArrow: "<i class='fa fa-chevron-right review-slider-arrow slick-next'></i>",
	speed: 1000,
	slidesToShow: 3,
	slidesToScroll: 1,
	appendArrows: '.review-row',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Full-Width-Slider"]) return;
  try {
    

$('.single-item.enabled').slick({
	infinite: true,
	autoplay: false,
	arrows: true,
	prevArrow: "<i class='fa fa-chevron-left home-slider-arrow slick-prev'></i>",
	nextArrow: "<i class='fa fa-chevron-right home-slider-arrow slick-next'></i>",
	speed: 1000,
	slidesToShow: 1,
	slidesToScroll: 1
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-section"]) return;
  try {
    

$('.collection-row').slick({
	infinite: false,
	autoplay: false,
	arrows: true,
	prevArrow: "<i class='fa fa-chevron-left collection-slider-arrow slick-prev'></i>",
	nextArrow: "<i class='fa fa-chevron-right collection-slider-arrow slick-next'></i>",
	speed: 1000,
	slidesToShow: 4,
	slidesToScroll: 1,
	dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
       autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
       autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
       autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows: true
      }
    }
]
});


  } catch(e) { console.error(e); }
})();

})();
